import { render, staticRenderFns } from "./ColumnValuation.vue?vue&type=template&id=766c1782&"
import script from "./ColumnValuation.vue?vue&type=script&lang=ts&"
export * from "./ColumnValuation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports